import { type RouterOutputs } from "~/utils/api"
import { roundForecast } from "~/utils/formatting"
import { round } from "lodash"

export type IAdjustment = RouterOutputs["adjustment"]["get"][number]

export const convertAdjustmentValue = (value: number, valueType: string) => {
  switch (valueType) {
    case "percentage":
      return round(value, 1) + " %"
    case "add":
      return roundForecast(value) + " per week"
    case "set":
      return "set to " + roundForecast(value) + " per week"
    default:
      return value
  }
}

export type AggregatedAdjustment = {
  variantIds: string[]
  value: number
  type: string
  theme: string
  name: string
  groupId: string
  warehouseId: string
  channels: string[]
  startDate: Date
  endDate: Date
  updatedBy: string
  updatedAt: Date
  locksForecast: boolean
  identifiers: {
    variantIds: string[]
    warehouseId: string
  }[]

  referencedAdjustments: IAdjustment[]
}
